import { connect } from 'react-redux';
import EsnMappingGridComponent from './esn-mapping-grid-component';

const mapStateToProps = (state: any) => ({
  results: state.management.esnMapping.grid.results,
  t: state.i18n.t
});

export default connect(mapStateToProps)(EsnMappingGridComponent);
